import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import TextField from 'components/form/text'
import { dismissValidationError } from 'actions/errors'
import { inviteeCanceledByErrorsSelector } from 'selectors'
import { useI18n } from 'locales'

const CanceledByField = ({
  className = null,
  onChange
}) => {
  const { i18n } = useI18n()
  const canceledByErrors = useSelector(inviteeCanceledByErrorsSelector)
  const dispatch = useDispatch()

  const dismissError = (event) => {
    dispatch(dismissValidationError('invitee', event.target.name))
  }

  return (
    <TextField
      required
      className={className}
      label={i18n.t('booking.templates.cancel_event_name_label')}
      name="canceled_by"
      onChange={onChange}
      onFocus={dismissError}
      error={canceledByErrors?.[0]}
    />
  )
}

CanceledByField.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default CanceledByField
